/**
 * TokenService
 *
 * Service for extracting data from tokens
 */
export default {

    /**
     * Returns the user object
     *
     * @returns {object}
     */
    user (token) {
        const data = JSON.parse(atob(token.split('.')[1]));
        return data.user;
    },

    /**
     * Returns the supplier object
     *
     * @param token
     * @returns {supplier}
     */
    suppliers (token) {
        const data = JSON.parse(atob(token.split('.')[1]));
        return data.suppliers;
    },

    /**
     * Returns the issuer value
     *
     * @returns {string}
     */
    iss (token) {
        const data = JSON.parse(atob(token.split('.')[1]));
        return data.iss;
    },

    /**
     * Returns the issued at value
     *
     * @returns {string}
     */
    iat (token) {
        const data = JSON.parse(atob(token.split('.')[1]));
        return data.iat;
    },

    /**
     * Returns the expiration value
     *
     * @returns {string}
     */
    exp (token) {
        const data = JSON.parse(atob(token.split('.')[1]));
        return data.exp;
    }
}



// WEBPACK FOOTER //
// ./src/services/TokenExtractionService.js